import Typography from "@mui/material/Typography";
import * as React from "react";
import {Box, useTheme} from "@mui/material";
import {observer} from "mobx-react";

function FormSection({title, header, children}) {
    const theme = useTheme();
    const style = styles(theme)

    return (
        <Box component="section" sx={style.formSectionContainer}>
            {header ? (
                header
            ) : (
                <Typography variant="h3" sx={style.formSectionTitle}>{title}</Typography>
            )}
            {children}
        </Box>
    )
}

export default observer(FormSection)

const styles = (theme) => ({
    formSectionContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: 'inherit',
        padding: '1.25rem 1.5rem',
        backgroundColor: theme.brand.field,
        border: `0.5px solid ${theme.palette.divider}`,
        borderRadius: '16px',
        marginBottom: '1.5rem',
    },
    formSectionTitle: {
        fontSize: '1.05rem',
        marginBottom: '1rem',
        paddingBottom: '0.6rem',
        borderBottom: `1px solid ${theme.palette.divider}`,
    }
})